/*
 * ShiftDetailCardApplicationStatus Messages
 *
 * This contains all the text for the ShiftDetailCardApplicationStatus component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.ShiftDetailCardApplicationStatus.title',
    defaultMessage: 'Application status',
  },
  // private
  private: {
    id: 'app.components.ShiftDetailCardApplicationStatus.private',
    defaultMessage: 'Draft',
  },
  privateDescription: {
    id: 'app.components.ShiftDetailCardApplicationStatus.privateDescription',
    defaultMessage:
      'This shift is being drafted and not visible to publishers.',
  },
  revoke: {
    id: 'app.components.ShiftDetailCardApplicationStatus.revoke',
    defaultMessage: 'Edit shift',
  },
  revokeSuccess: {
    id: 'app.components.ShiftDetailCardApplicationStatus.revokeSuccess',
    defaultMessage: 'Successfully returned to draft mode',
  },
  revokeFailure: {
    id: 'app.components.ShiftDetailCardApplicationStatus.revokeFailure',
    defaultMessage: 'Error. Failed returning to draft mode.',
  },
  deleteSuccess: {
    id: 'app.components.ShiftDetailCardApplicationStatus.deleteSuccess',
    defaultMessage: 'Successfully deleted shift',
  },
  deleteFailure: {
    id: 'app.components.ShiftDetailCardApplicationStatus.deleteFailure',
    defaultMessage: 'Error. Failed deleting the shift.',
  },
  delete: {
    id: 'app.components.ShiftDetailCardApplicationStatus.delete',
    defaultMessage: 'Delete shift',
  },
  // frozen
  frozen: {
    id: 'app.components.ShiftDetailCardApplicationStatus.frozen',
    defaultMessage: 'Application stop',
  },
  frozenDescription: {
    id: 'app.components.ShiftDetailCardApplicationStatus.frozenDescription',
    defaultMessage:
      'Publishers can see the shift but not apply for it anymore.',
  },
  freeze: {
    id: 'app.components.ShiftDetailCardApplicationStatus.freeze',
    defaultMessage: 'Stop applications',
  },
  freezeSuccess: {
    id: 'app.components.ShiftDetailCardApplicationStatus.freezeSuccess',
    defaultMessage: 'Successfully stopped applications',
  },
  freezeFailure: {
    id: 'app.components.ShiftDetailCardApplicationStatus.freezeFailure',
    defaultMessage: 'Error. Failed stopping applications.',
  },
  thaw: {
    id: 'app.components.ShiftDetailCardApplicationStatus.thaw',
    defaultMessage: 'Reopen shift for applications',
  },
  thawSuccess: {
    id: 'app.components.ShiftDetailCardApplicationStatus.thawSuccess',
    defaultMessage: 'Successfully reopened shift for applications',
  },
  thawFailure: {
    id: 'app.components.ShiftDetailCardApplicationStatus.thawFailure',
    defaultMessage: 'Error. Failed to reopen shift for applications.',
  },
  // releasing
  released: {
    id: 'app.components.ShiftDetailCardApplicationStatus.released',
    defaultMessage: 'Open for applications',
  },
  releasedDescription: {
    id: 'app.components.ShiftDetailCardApplicationStatus.releasedDescription',
    defaultMessage: 'Publishers can see and apply for this shift.',
  },
  release: {
    id: 'app.components.ShiftDetailCardApplicationStatus.release',
    defaultMessage: 'Open shift for applications',
  },
  releaseSuccess: {
    id: 'app.components.ShiftDetailCardApplicationStatus.releaseSuccess',
    defaultMessage: 'Successfully opened shift for applications',
  },
  releaseFailure: {
    id: 'app.components.ShiftDetailCardApplicationStatus.releaseFailure',
    defaultMessage: 'Error. Failed to open shift for applications.',
  },
  // releasing confirmation dialog
  releaseConfirmTitle: {
    id: 'app.components.ShiftDetailCardApplicationStatus.releaseConfirmDialogTitle',
    defaultMessage: 'Open shift for applications?',
  },
  releaseConfirmText: {
    id: 'app.components.ShiftDetailCardApplicationStatus.releaseConfirmDialogText',
    defaultMessage:
      'Opening the shift for applications will make it visible to publishers and allow them to apply for it.',
  },
  releaseConfirmButton: {
    id: 'app.components.ShiftDetailCardApplicationStatus.releaseConfirmDialogButton',
    defaultMessage: 'Open shift for applications',
  },
  releaseConfirmCancel: {
    id: 'app.components.ShiftDetailCardApplicationStatus.releaseConfirmDialogCancel',
    defaultMessage: 'Cancel',
  },
  releaseFailed: {
    id: 'app.components.ShiftDetailCardApplicationStatus.releaseFailed',
    defaultMessage: 'Error. The shift could not be opened for applications.',
  },
});
